"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _MakeConnectedAPIDropdownProvider = _interopRequireDefault(require("customer-data-reference-ui-components/connector/MakeConnectedAPIDropdownProvider"));

var _ReferenceObjectTypes = require("reference-resolvers/constants/ReferenceObjectTypes");

var _UserReferenceResolver = _interopRequireDefault(require("reference-resolvers/resolvers/UserReferenceResolver"));

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _I18n = _interopRequireDefault(require("I18n"));

var UserSelect = (0, _MakeConnectedAPIDropdownProvider.default)({
  referenceObjectType: _ReferenceObjectTypes.USER,
  referenceResolver: _UserReferenceResolver.default
});
var propTypes = {
  handleUserOpenChange: _propTypes.default.func.isRequired,
  isUserFilterOpen: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  value: _reactImmutableProptypes.default.list.isRequired
};

var TimelineFilterUsers =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(TimelineFilterUsers, _PureComponent);

  function TimelineFilterUsers() {
    var _this;

    (0, _classCallCheck2.default)(this, TimelineFilterUsers);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TimelineFilterUsers).call(this));
    _this.renderButtonContent = _this.renderButtonContent.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(TimelineFilterUsers, [{
    key: "renderButtonContent",
    value: function renderButtonContent() {
      var value = this.props.value;

      if (!value || !value.size) {
        return _react.default.createElement(_FormattedMessage.default, {
          message: "profileContentTimeline.filters.users.noneSelected"
        });
      }

      return _react.default.createElement(_FormattedMessage.default, {
        message: "profileContentTimeline.filters.users.selected",
        options: {
          count: value.size
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(UserSelect, {
        "data-selenium-test": "timeline-filter-users",
        buttonUse: "transparent",
        menuWidth: "auto",
        multi: true,
        onChange: this.props.onChange,
        placeholder: _I18n.default.text('profileContentTimeline.filters.users.noneSelected'),
        value: this.props.value.toArray(),
        showTags: false,
        ButtonContent: this.renderButtonContent,
        open: this.props.isUserFilterOpen,
        onOpenChange: this.props.handleUserOpenChange
      });
    }
  }]);
  return TimelineFilterUsers;
}(_PureComponent2.default);

TimelineFilterUsers.propTypes = propTypes;
var _default = TimelineFilterUsers;
exports.default = _default;
module.exports = exports.default;